<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                        <h3>طلبات انضمام ابنائي</h3>
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسية'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسية</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'طلبات انضمام ابنائي'" :to="{name: 'requests'}">طلبات انضمام ابنائي</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                          جميع البيانات
                                        <create-button  v-if="hasPermissions('requests_create')" :routeName="'requests.create'"></create-button>

                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <div class="table-responsive">
                                  <div class="row mb-2">
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    <table class="table table-bordered mb-4">
                                        <thead>
                                            <tr>
                                                <th>
                                                  <a href="#" @click.prevent="resortData();">
                                                    <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                    <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                  </a>
                                                </th>
                                                <th @click="resortData();">اسم الطالب</th>
                                                <th @click="resortData();">الصف</th>
                                                <th @click="resortData();">المرحلة الدراسية</th>
                                                <th @click="resortData();">تاريخ الطلب</th>
                                                <th @click="resortData();">حالة الطلب</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in data.data" :key="index">
                                                <td>{{index+1}}</td>
                                                <td>{{item.name}}</td>
                                                <td>{{item.stage ? item.stage.name : '---'}}</td>
                                                <td>{{item.group ? item.group.name : '---'}}</td>
                                                <td>{{item.request_date}}</td>
                                                <td>
                                                    <span class="badge badge-warning" v-if="item.status == 0">غير مفعل</span>
                                                    <span class="badge badge-success" v-else>قام بالمقابلة الشخصية</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                           <tr>
                                                <th>
                                                  <a href="#" @click.prevent="resortData();">
                                                    <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                    <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                  </a>
                                                </th>
                                                <th @click="resortData();">اسم الطالب</th>
                                                 <th @click="resortData();">الصف</th>
                                                <th @click="resortData();">المرحلة الدراسية</th>
                                                <th @click="resortData();">تاريخ الطلب</th>
                                                <th @click="resortData();">حالة الطلب</th>
                                            </tr>
                                        </tfoot>

                                    </table>
                                </div>
                                <div class="row">
                                  <div class="col-md-10">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-2 mt-4 text-left">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>


</template>
<script>

export default {
  data() {
    return {
      data: {
        data: {},
        searching:{
            id: '',
            name: '',
            email: '',
           created_at: '',
           perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      }
    };
  },
  created(){
      this.flashAlert();
      this.getIndexData(1);
  },
  methods: {
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
      getIndexData(page){
        this.$baseApi.get('/requests?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.paginated = response.data.data.requests;
               this.data.data = response.data.data.requests.data;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
</style>
